import { computed } from "vue";
import { useRoute } from "vue-router/composables";

export default () => {
  const route = useRoute();
  const { viewMode, id } = route.params;
  const { view } = route.query;

  const currentView = computed(() => {
    if (!viewMode || !view) return "";

    if (id) return "Detail";

    if (viewMode === "list") {
      if (view === "long") return "Standard";
      if (view === "short") return "Compact";
      return "List";
    }

    return `${viewMode.charAt(0).toUpperCase()}${viewMode.substring(1)}`;
  });

  return {
    currentView
  };
};
